export enum EventTypeEnum {
    Lessons,
    Camp,
    Training
}